"use client";

import cn from "classnames";
import Image from "next/image";
import { Drawer } from "@mui/material";

import { I18NDropdown } from "@/src/component/partial/I18NDropdown";
import type { StrapiSingleType, StrapiCollectionType } from "@/src/type";

import { TitleLink, SimpleLink } from "./component";

import styles from "./MarketingNav.module.scss";
import theme from "@/styles/scss/theme.module.scss";

interface MarketingNavProps {
  drawerOpen: boolean;
  setDrawerOpen: (drawerOpen: boolean) => void;
  webConfig: StrapiSingleType.WebConfig;
  nav?: StrapiCollectionType.Navigation;
}

function MarketingNav({ drawerOpen, setDrawerOpen, nav }: MarketingNavProps) {
  const breakpointKey = `@media (max-width: ${theme.breakpointSMNum}px)`;

  return (
    <Drawer
      anchor="left"
      onClose={() => setDrawerOpen(false)}
      open={drawerOpen}
      //variant="persistent"
      className={styles.drawerScrollbar}
      PaperProps={{
        sx: {
          width: 400,
          maxWidth: 400,
          [breakpointKey]: {
            width: "100%",
            maxWidth: "100%",
          },
          zIndex: 4000,
        },
      }}
    >
      <div
        className={styles.drawerHeader}
        data-testid="navbar-drawer"
      >
        <div className={styles.drawerHeaderLeft}>
          <div
            className={styles.waveIcon}
            onClick={() => setDrawerOpen(!drawerOpen)}
          >
            <Image
              src="/image/icon_flow_wave.svg"
              width={32}
              height={20}
              alt="Flow Wave Icon"
            />
          </div>
          <div className={styles.localeSelector}>
            <I18NDropdown
              color={"dark"}
              placement="bottom-start"
              drawer={true}
            />
          </div>
        </div>
        <div
          className={styles.drawerHeaderRight}
          onClick={() => setDrawerOpen(!drawerOpen)}
        >
          <Image
            src="/image/icon_exit.svg"
            width={22}
            height={23}
            alt="Exit Menu"
          />
        </div>
      </div>
      <div className={styles.divider} />
      <div className={styles.titleLinkContainer}>{nav && <TitleLink nav={nav} />}</div>
      <div className={styles.simpleLinkContainer}>
        {(nav?.topNav ?? []).map((navItem, index) => (
          <SimpleLink
            key={index}
            closeDrawer={() => setDrawerOpen(!drawerOpen)}
            navItem={navItem}
          />
        ))}
      </div>
      <div className={styles.divider} />
      {(nav?.bottomNav?.data ?? []).map((opt, i) => (
        <div key={opt.id}>
          <div className={cn(styles.titleLinkContainer, styles.bottom)}>
            <TitleLink
              nav={opt.attributes}
              isBottom={true}
            />
          </div>
          <div className={styles.simpleLinkContainer}>
            {(opt?.attributes?.topNav ?? []).map((navItem, index) => (
              <SimpleLink
                key={index}
                closeDrawer={() => setDrawerOpen(!drawerOpen)}
                navItem={navItem}
              />
            ))}
          </div>
          {(nav?.bottomNav?.data ?? []).length !== i + 1 && <div className={styles.divider} />}
        </div>
      ))}
    </Drawer>
  );
}

export default MarketingNav;
